const pageNameKey = "timeSeriesLineNoData";

export const timeSeriesLineNoDataEn = {
  [pageNameKey]: {
    noData: "Not enough numeric data!",
  },
};

export const timeSeriesLineNoDataPtBr = {
  [pageNameKey]: {
    noData: "Dados numéricos insuficientes!",
  },
};

export const timeSeriesLineNoDataDe = {
  [pageNameKey]: {
    noData: "Nicht genügend numerische Daten!",
  },
};

export const timeSeriesLineNoDataZhHans = {
  [pageNameKey]: {
    noData: "没有足够的数值数据！",
  },
};

export const timeSeriesLineNoDataIt = {
  [pageNameKey]: {
    noData: "Dati numerici insufficienti!",
  },
};

export const timeSeriesLineNoDataEs = {
  [pageNameKey]: {
    noData: "¡No hay suficientes datos numéricos!",
  },
};

export const timeSeriesLineNoDataNl = {
  [pageNameKey]: {
    noData: "Onvoldoende numerieke gegevens!",
  },
};

export const timeSeriesLineNoDataTr = {
  [pageNameKey]: {
    noData: "Yeterli sayısal veri yok!",
  },
};
